import { drop } from '@execonline-inc/collections';
import { assertNever } from '@kofno/piper';
import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { emptyFragment } from '../../../../../../../../EmptyFragment';
import { T } from '../../../../../../../../Translations';
import { useOpenable } from '../../../../../../../Modal/UseOpenable';
import { ScheduledProgramInstanceOption } from '../../../../../../Types';
import StartDate from './StartDate';

export interface Props {
  options: ReadonlyArray<ScheduledProgramInstanceOption>;
}

const ExcessStartDates: React.FC<Props> = ({ options }) => {
  const { modalState, open, close } = useOpenable();

  switch (modalState.kind) {
    case 'open':
      return (
        <>
          {drop(4, options).map((scheduledOption) => (
            <StartDate scheduledOption={scheduledOption} key={scheduledOption.id} />
          ))}
          <div onClick={close} className="cursor-pointer text-teal-600 col-span-4 mx-auto mt-4">
            <T kind="Show fewer" />
          </div>
        </>
      );
    case 'closed':
      return fromEmpty(options)
        .map((options) => (
          <div onClick={open} className="cursor-pointer text-teal-600 col-span-4 mx-auto mt-4">
            <T kind="Show all {{count}} dates" count={options.length} />
          </div>
        ))
        .getOrElse(emptyFragment);
    default:
      assertNever(modalState);
  }
};

export default observer(ExcessStartDates);
